import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';
import { Fade } from 'react-awesome-reveal';
import { 
  FaPaperPlane, 
  FaUser, 
  FaAt, 
  FaPencilAlt 
} from '../../common/Icons';
import './Contact.css';

const Contact = () => {
  const form = useRef<HTMLFormElement>(null);
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [isError, setIsError] = useState(false);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSending(true);
    setIsSent(false);
    setIsError(false);

    if (!form.current) {
      console.error("Error: La referencia al formulario es nula.");
      setIsSending(false);
      setIsError(true);
      return;
    }

    emailjs.sendForm(
      'service_5r7dgwk',
      'template_vxz9ihu',
      form.current,
      'KLHTOnh4vmbMLrD6H'
    )
    .then((result) => {
        console.log(result.text);
        setIsSending(false);
        setIsSent(true);
        form.current?.reset(); 
    }, (error) => {
        console.log(error.text);
        setIsSending(false);
        setIsError(true);
    });
  };

  return (
    <div className="contact-container full-page-section" id="contact">
      
      <div className="contact-main-wrapper">
        
        <Fade direction="up" triggerOnce={true} fraction={0.1}>
          <h2 className="contact-title-h2">
            <span>// Contact Me</span>
          </h2>
        </Fade>
        
        <Fade direction="up" triggerOnce={true} fraction={0.1} delay={100}>
          <p>
            Have a question, a project proposal, or just want to connect?
            Feel free to send me a message.
          </p>
        </Fade>
        
        <div className="contact-form-wrapper">
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            
            <Fade direction="up" triggerOnce={true} fraction={0.1} delay={100} cascade damping={0.2}>
              
              <div className="form-group">
                <label htmlFor="user_name"><FaUser /> Name</label>
                <input id="user_name" type="text" name="user_name" required />
              </div>
              
              <div className="form-group">
                <label htmlFor="user_email"><FaAt /> Email</label>
                <input id="user_email" type="email" name="user_email" required />
              </div>
              
              <div className="form-group">
                <label htmlFor="message"><FaPencilAlt /> Message</label>
                <textarea id="message" name="message" rows={7} required></textarea>
              </div>
              
              <button type="submit" className="submit-btn" disabled={isSending}>
                {isSending ? 'Sending...' : (
                  <>
                    Send Message <FaPaperPlane />
                  </>
                )}
              </button>
            </Fade>
          </form>
        </div> 

        {isSent && (
          <p className="status-message success">
            Message sent! Thank you for reaching out. I'll review it and be in touch soon.
          </p>
        )}        
        {isError && <p className="status-message error">Failed to send message. Please try again.</p>}

      </div> 

    </div>
  );
};

export default Contact;